import { ColorEvent } from 'ngx-color';
import { NgbModal, NgbModalRef } from "@ng-bootstrap/ng-bootstrap";

import { ITemplate } from "../../template-preview/template-preview.component";

import { MobileChartOptionsModalComponent } from "./mobile-chart-options-modal.component";

export function ShowMobileColorPicker(modalService: NgbModal, defaultColor = '#FFFFFF', title='Pick a color'): Promise<ColorEvent> {
    const mobile = true;
    const component = MobileChartOptionsModalComponent;
    const windowClass = "dark-modal" + (mobile? ' mobile': '');
    const m: NgbModalRef = modalService.open(component, {
        backdrop: "static",
        size: "sm",
        centered: true,
        windowClass: windowClass
    });
    const modal = (<MobileChartOptionsModalComponent>m.componentInstance);
    modal.colorPickerTitle = title;
    modal.defaultPickerColor = defaultColor;
    modal.colorPickerMode = true;
    return m.result;
}